import { Fragment } from 'react';
import { useIntl } from 'react-intl';

import './subtitle.scss';

import type { MultiFlightEntityType } from 'sonata-static-storage/lib/common/common.types';

type Props = {
  campaignPlanName?: string;
  ioName?: string;
  ioNumbers?: number;
  lineItems?: number;
  type?: MultiFlightEntityType;
};

function Subtitle({ campaignPlanName, ioName, ioNumbers, lineItems, type }: Props) {
  const { formatMessage } = useIntl();
  const componentsList: JSX.Element[] = [];
  if (type === 'campaignPlan') {
    componentsList.push(
      <span className="subtitle__group">
        {ioNumbers ? (
          <>
            <span>
              {formatMessage({
                defaultMessage: 'IOs:',
                id: 'subtitle.io'
              })}
            </span>
            <span className="subtitle__ioNumbers">{ioNumbers}</span>
          </>
        ) : (
          <span>
            {formatMessage({
              defaultMessage: 'No Insertion Orders assigned',
              id: 'subtitle.noIo'
            })}
          </span>
        )}
      </span>
    );
  }
  if (type === 'campaignPlan' || type === 'insertionOrder') {
    componentsList.push(
      <span className="subtitle__group">
        {lineItems ? (
          <>
            <span>
              {formatMessage({
                defaultMessage: 'LIs:',
                id: 'subtitle.li'
              })}
            </span>
            <span className="subtitle__lineItems">{lineItems}</span>
          </>
        ) : (
          <span>
            {formatMessage({
              defaultMessage: 'No Line Items assigned',
              id: 'subtitle.noLi'
            })}
          </span>
        )}
      </span>
    );
  }
  if (campaignPlanName) {
    componentsList.push(
      <span className="subtitle__campaignPlan" title={campaignPlanName}>
        {campaignPlanName}
      </span>
    );
  }
  if (ioName) {
    componentsList.push(
      <span className="subtitle__insertionOrder" title={ioName}>
        {ioName}
      </span>
    );
  }
  const Separator = <span className="subtitle__separator">/</span>;
  return (
    <div className="subtitle">
      {componentsList.map((Comp, index) => {
        return (
          <Fragment key={index}>
            {index !== 0 ? Separator : ''}
            {Comp}
          </Fragment>
        );
      })}
    </div>
  );
}

export default Subtitle;
